import { useEffect, useState } from 'react';
import { Card, Skeleton, Tabs } from 'antd';
import { productsHomeData } from '../constants/TempData';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';

const TabsHome = () => {
    const [loading, setLoading] = useState(true);
    const [groupedData, setGroupedData] = useState({});
    const [activeKey, setActiveKey] = useState('0');
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [shop, setShop] = useState([
        {
            title: "",
            salePrice: "",
            originalPrice: "",
            image: [],
            code: "",
            category:""
        }
    ]);
    console.log("Shop", shop)
    

    useEffect(() => {
        // Simulate initial loading
        const grouped = productsHomeData.reduce((acc, product) => {
            if (!acc[product.category]) {
                acc[product.category] = [];
            }
            acc[product.category].push(product);
            return acc;
        }, {});
        setGroupedData(grouped);
        // Simulate loading delay
        setTimeout(() => setLoading(false), 1500);
    }, []);

    const handleTabChange = (key) => {
        setActiveKey(key);
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
        }, 1000); // simulate loading when changing tabs
    };
    const categories = Object.keys(groupedData);
    const tabItems = categories.map((category, index) => ({
        key: String(index),
        label: t(category),
        children: (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px' }}>
                {groupedData[category].map((card, idx) => (
                    <Card
                        key={idx}
                        hoverable
                        style={{ width: 240 }}
                        onClick={() => handleViewDetail(card)}
                        cover={
                            loading ? (
                                <Skeleton.Image style={{ width: 240, height: 250 }} active />
                            ) : (
                                <img
                                    alt={card.title}
                                    src={card.image[0]}
                                    style={{ height: '250px', objectFit: 'cover' }}
                                />
                            )
                        }
                    >
                        {loading ? (
                            <div className='d-flex'>
                                <Skeleton active paragraph={{ rows: 1 }} title={false} />
                                <Skeleton active paragraph={{ rows: 1 }} title={false} />
                            </div>
                        ) : (
                            <div>
                                <h6 className='labelHeader18600'>{t(card.title)}</h6>
                                {/* <h6 className='labelHeader18700'>$ {card.salePrice}</h6> */}
                            </div>
                        )}
                    </Card>
                ))}
            </div>
        ),
    }));
    useEffect(() => {
        // Simulate loading
        setTimeout(() => {
            const grouped = productsHomeData.reduce((acc, product) => {
                if (!acc[product.category]) {
                    acc[product.category] = [];
                }
                if (acc[product.category].length < 5) {
                    acc[product.category].push(product);
                }
                return acc;
            }, {});
            setGroupedData(grouped);
            setLoading(false);
        }, 1500);
    }, []);


    const fetchBlog = async () => {
        const res = productsHomeData;

        setShop([...res])
    }
    const handleViewDetail = (item) => {
        navigate(`/shop/${item.code}`, { state: { shop: item } });
    }
    useEffect(() => {
        fetchBlog();
    }, [])

    return (
        <>
            <Tabs
                activeKey={activeKey}
                items={tabItems}
                className="custom-tabs"
                options={['start']}
                size='large'
                tabBarStyle={{
                    border: "none"
                }}
                onChange={handleTabChange}
                indicator={{
                    size: origin => origin - 20,
                    align: 'start',
                }}
            />
            {/* <VideoCard /> */}
        </>
    );
};
export default TabsHome;